import {
  MAX_HOMEWORK_TRACE_NODE_MOVES,
  MAX_HOMEWORK_TRACE_NODES,
  type HomeworkAnswerTraceNode,
  type ProblemMoveIntent,
} from '@wx-weiqi/contracts';

function sameMove(left: ProblemMoveIntent, right: ProblemMoveIntent): boolean {
  return (
    left.kind === right.kind &&
    (left.kind === 'PASS' ||
      (right.kind === 'PLAY' && left.point.x === right.point.x && left.point.y === right.point.y))
  );
}

export function appendHomeworkAnswerTraceNode(
  existing: readonly HomeworkAnswerTraceNode[],
  parentNodeIndex: number | null,
  previousAnswer: readonly ProblemMoveIntent[],
  nextAnswer: readonly ProblemMoveIntent[],
): Readonly<{
  nodes: readonly HomeworkAnswerTraceNode[];
  nodeIndex: number;
}> | null {
  if (
    existing.length >= MAX_HOMEWORK_TRACE_NODES ||
    previousAnswer.length >= nextAnswer.length ||
    previousAnswer.some((move, index) => {
      const nextMove = nextAnswer[index];
      return nextMove === undefined || !sameMove(move, nextMove);
    })
  ) {
    return null;
  }
  const moves = nextAnswer.slice(previousAnswer.length);
  if (moves.length > MAX_HOMEWORK_TRACE_NODE_MOVES) return null;
  const nodeIndex = existing.length;
  return Object.freeze({
    nodes: Object.freeze([
      ...existing,
      {
        parentNodeIndex,
        moves,
      },
    ]),
    nodeIndex,
  });
}
